import React from 'react';

/**
 * Generates an output row for a given associated object (company or person)
 * based on the fields that are present in the object.
 * 
 * @param {string} title The title to be displayed on the left side
 * @param {object} associated The associated object to be displayed on the right side
 */
export default ({ title, associated }) => {
    if (!associated) return null;
    let output = [<span key="title">{ title }</span>, <span key="line" className="line"></span>];

    let elements = [];
    let i = 0;
    for (let company of associated) {
        if (!company.company && !company.person) continue;
        let text = company.company || company.person;

        let innerHTML = {__html: text};

        if (company.homepage) {
            let url = company.homepage;
            if (url.substring(0, 4) != 'http') url = 'http://' + url;

            elements.push(<a className="entry" href={ url } target="_blank" rel="nofollow" key={ i } dangerouslySetInnerHTML={innerHTML} />);
        } else {
            elements.push(<span className="entry" key={ i } dangerouslySetInnerHTML={innerHTML} />);
        }
        
        i++;
    }

    if (!elements.length) return;

    let right = <span className="content" key="value">{ elements }</span>;
    output.push(right);
    return output;

    if (associated.homepage) {
        let url = associated.homepage;
        if (url.substring(0, 4) != 'http') url = 'http://' + url;

        output.push(
            <span className="with-url" key="value">
                <a href={ url } target="_blank" rel="nofollow" className="content" key={ 'value' }>{ text }</a>
            </span>
        );
    } else {
        output.push(<span key="value" className="content">{ text }</span>);
    }

    return output;
}
